import classnames from 'classnames';

interface SeparatorProps {
  width: string;
  noMarginTop?: boolean;
  white?: boolean;
  color?: string;
}

export const Separator = ({ width, noMarginTop, white, color }: SeparatorProps) => (
  <div
    className={classnames(
      'border',
      noMarginTop ? 'mt-0' : 'mt-[20px]',
      color ? color : 'border-border_balance_sidebar',
      width,
      {
        'border-text-2': Boolean(white)
      }
    )}
  />
);
